module.exports = __webpack_public_path__ + "static/media/topback.3bda4575.jpg";